import React from "react";
import styles from "./AverageRating.module.scss";

import AverageStars from "../AverageStars/AverageStars";

const AverageRating = ({ average = 0, count = 0 }) => (
  <div
    className={`${styles.AverageRating} d-flex align-items-center justify-content-center mb-2`}
    data-testid="AverageRating"
  >
    <AverageStars average={average} maxScore={5} />
    <div className="ml-2" />
    <span className={styles.RatingAverage}>{average.toFixed(1)}</span>
    <span className={styles.RatingCount}>({count})</span>
  </div>
);

AverageRating.propTypes = {};

AverageRating.defaultProps = {};

export default AverageRating;
